import React from 'react';

import { getARIATranslations } from '../../hooks/aria-translations';
import {
  SliderButtonNext,
  SliderButtonPause,
} from '../slider-button/slider-button';

type ControlsProps = {
  isPaused: boolean;
  play: () => void;
  pause: () => void;
};

export const Controls = ({ isPaused, play, pause }: ControlsProps) => {
  const { label_pause, label_play } = getARIATranslations();
  return isPaused ? (
    <SliderButtonNext
      onClick={play}
      ariaLabel={label_play}
      styling={{ fillMode: 'outlined', color: 'white' }}
      hoverStyling={{ fillMode: 'outlined', color: 'light-red' }}
    ></SliderButtonNext>
  ) : (
    <SliderButtonPause
      onClick={pause}
      ariaLabel={label_pause}
      styling={{ fillMode: 'outlined', color: 'white' }}
      hoverStyling={{ fillMode: 'outlined', color: 'light-red' }}
    ></SliderButtonPause>
  );
};
